export const ALIGN_CONTENT_CLASSES = {
    normal: 'content-normal',
    center: 'content-center',
    'flex-start': 'content-start',
    'flex-end': 'content-end',
    'space-between': 'content-between',
    'space-around': 'content-around',
    'space-evenly': 'content-evenly',
    baseline: 'content-baseline',
    stretch: 'content-stretch',
};
export const applyAlignContent = (alignContent) => [
    ...(alignContent ? [ALIGN_CONTENT_CLASSES[alignContent]] : []),
];
